import React, { useContext } from "react";
import { Box, Flex } from "@src/components/Boxes";
import styled from "@emotion/styled";
import Container from "@src/components/Container";
import { graphql, useStaticQuery } from "gatsby";
import { mediaQueries } from "@src/styles/theme";
import Translate from "@src/components/translation/Translate";
import IconCard from "@src/components/IconCard";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import { Space, theme } from "@src/components/nessie-web";

const ItemWrapper = styled(Box)`
  padding-left: 15px;
  padding-right: 15px;
`;
ItemWrapper.defaultProps = { width: ["100%", 1 / 2] };

const ItemBox = styled(Flex)`
  position: relative;
  background: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(201, 201, 201, 0.5);
  border-radius: 5px;
  padding: 77px 20px 30px;
  width: 100%;
  margin-bottom: 66px;
`;

ItemBox.defaultProps = { flexDirection: "column", alignItems: "center" };

const ItemBoxImg = styled.img`
  position: absolute !important;
  top: -37.5px;
  margin: 0 auto;
`;

const Header = styled("h2")`
  text-align: center;
  padding: 76px 0 25px 0;
  margin-top: 0;
  font-weight: 800;
  font-size: 24px;
  color: ${(props: any) => props.theme.colors.text};
  line-height: 32px;
  ${mediaQueries[2]} {
    line-height: 40px;
  }
`;

const Grid = styled.div`
  display: grid;
  gap: ${theme.space.l}px;
  grid-template-columns: 1fr;
  ${mediaQueries[1]} {
    gap: ${theme.space.xxl}px;
    grid-template-columns: 1fr 1fr;
  }
`;

const ParentResourcesSection: React.FC = () => {
  const data = useStaticQuery(graphql`
    query {
      directus {
        page_resources {
          parents_items
        }
      }
    }
  `);

  const {
    directus: {
      page_resources: { parents_items },
    },
  } = data;

  const { translate } = useContext(TranslationContext);

  return (
    <Box as="section" backgroundColor="#f5f5f3" paddingBottom={[40, 60]}>
      <Container>
        <Header id="parents">
          <Translate path="pages.resources_new.parents_resources.title" />
        </Header>
        <Space size="l" />
        <Box margin="auto">
          <Grid>
            {parents_items.map((item, index) => (
              <div key={index} style={{ paddingTop: 54, display: "flex" }}>
                <IconCard
                  iconOffset
                  icon={item.icon_url}
                  title={translate(`directus.page_resources.parents_items.title_${index + 1}`)}
                  description={translate(`directus.page_resources.parents_items.text_${index + 1}`)}
                  buttonLabel={translate(`directus.page_resources.parents_items.button_${index + 1}`)}
                  href={item.button_url}
                  kind="tertiary"
                />
              </div>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ParentResourcesSection;
